export const APP_NAME = 'VideoMule';
export const APP_DESCRIPTION =
  'VideoMule is an AI tutorial video maker that turns screen recordings into professional videos with automatic voice-over — fast, easy, and built for creators.';
export const SEO_TITLE =
  'AI Tutorial Video Maker with AI Voiceover | VideoMule';

export const ADDRESS =
  'WL Craft LLC, No. 80 North Gould street, Sheridan Wyoming. Zip- 82801';

export const SUPPORT_EMAIL = 'support@videomule.ai';

export const CONTACT_PHONE = '+91-9025525350';
